"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalController = function () {
  /*@ngInject*/
  function ModalController($uibModalInstance, stripe, title, text, application, Applications) {
    _classCallCheck(this, ModalController);

    this._Applications = Applications;
    this.payment = {};
    this._stripe = stripe;
    this._$uibModalInstance = $uibModalInstance;
    this.application = application;
    this.title = title;
    this.text = text;
    this.data = {};
    this.error = null;
  }

  _createClass(ModalController, [{
    key: "ok",
    value: function ok() {
      this._$uibModalInstance.close(this.data);
    }
  }, {
    key: "acceptApp",
    value: function acceptApp(data) {
      var _this = this;

      this._Applications.capture(data).then(function (response) {
        _this.error = null;
        _this._$uibModalInstance.close(response);
      }).catch(function (err) {
        console.log(err);
        _this.error = err.data.message;
      });
    }
  }, {
    key: "waitApp",
    value: function waitApp(data) {
      var _this2 = this;

      console.log(data);
      data.newStatus = "Wait List";
      this._Applications.refund(data).then(function (response) {
        _this2.error = null;
        _this2._$uibModalInstance.close(response);
      }).catch(function (err) {
        console.log(err);
        _this2.error = err.data.message;
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._$uibModalInstance.dismiss("cancel");
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this3 = this;

      console.log("Stripe Token Test");
      this._stripe.card.createToken(this.payment).then(function (response) {
        console.log(response);
        _this3.error = null;

        _this3.payment.number = void 0;
        _this3.payment.cvc = void 0;
        _this3.payment.exp_month = void 0;
        _this3.payment.exp_year = void 0;
        _this3.payment.token = response.id;


        _this3.application.ip = response.client_ip;

        _this3.application.charge = {
          token: response.id,
          cardholder: response.card.name,
          billing: {
            line1: response.card.address_line1,
            line2: response.card.address_line2,
            city: response.card.address_city,
            state: response.card.address_state,
            zip: response.card.address_zip
          },
          cardId: response.card.id,
          last4: response.card.last4,
          brand: response.card.brand
        };

        return _this3._$uibModalInstance.close(_this3.application);
      }).catch(function (err) {
        if (err.type && /^Stripe/.test(err.type)) {
          console.log("Stripe error: ", err.message);
          _this3.error = err.message;
        } else {
          console.log("Other error occurred, possibly with your API", err.message);
          _this3.error = err.message;
        }
      });
    }
  }, {
    key: "fillBilling",
    value: function fillBilling() {
      this.payment.address_line1 = this.application.address.line1;
      this.payment.address_line2 = this.application.address.line2;
      this.payment.address_city = this.application.address.city;
      this.payment.address_state = this.application.address.state;
      this.payment.address_zip = this.application.address.zip;
    }
  }]);

  return ModalController;
}();

exports.default = ModalController;


// WEBPACK FOOTER //
// ./client/components/modal/modal.controller.js